<span
  class="title"
  [ngStyle]="{ color: 'var(--color-' + color + ')', 'font-weight': weight }"
  [class.--flex]="flex"
>
  <ng-content></ng-content>
</span>
